import { Outlet, Route, Routes } from 'react-router-dom';

import { WebAppLayout } from '../layouts/WebAppLayout';
import { EmptyLayout } from '../layouts/EmptyLayout';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { ApplicationRoutes, ProfileNestedRoutes, RULES_COMPETE_URL, RULES_NEW_URL } from '../constants';
import { ProfileAchievements } from '../components/ProfileAchievements';

import { HomePage } from './HomePage/HomePage';
import { SearchPage } from './SearchPage/SearchPage';
import { CourseListPage } from './CourseListPage/CourseListPage';
import { CoursePage } from './CoursePage/CoursePage';
import { ChapterPage } from './ChapterPage/ChapterPage';
import { PromptPage } from './PromptPage/PromptPage';
import { ChallengeListPage } from './ChallengeListPage/ChallengeListPage';

import { NewPromptPage } from './NewPromptPage/NewPromptPage';
import { NewPromptSuccessPage } from './NewPromptSuccessPage/NewPromptSuccessPage';
import { NewPromptFailurePage } from './NewPromptFailurePage/NewPromptFailurePage';
import { NewPromptStatusPage } from './NewPromptStatusPage/NewPromptStatusPage';

import { MyProfilePage, MyProfilePrompts, MyProfileFavorites, MyProfileRating } from './MyProfilePage';
import { ProfilePage, ProfilePrompts, ProfileRating } from './ProfilePage';

import { NotFoundPage } from './NotFoundPage/NotFoundPage';
import { ChallengePage } from './ChallengePage/ChallengePage';
import { RulesRedirectPage } from './RulesRedirectPage';
import { PromoResearchPage } from './PromoResearchPage';
import { PromoMuseumNightPage } from './PromoMuseumNightPage';

export const AppRoutes = () => {
    const renderLayout = () => (
        <WebAppLayout>
            <Outlet />
        </WebAppLayout>
    );

    const renderEmptyLayout = () => (
        <EmptyLayout>
            <Outlet />
        </EmptyLayout>
    );

    return (
        <Routes>
            {/* Роуты для правил - должны быть выше общих роутов */}
            <Route
                path={ApplicationRoutes.CompeteRules}
                element={<RulesRedirectPage redirectUrl={RULES_COMPETE_URL} />}
            />
            <Route path={ApplicationRoutes.NewRules} element={<RulesRedirectPage redirectUrl={RULES_NEW_URL} />} />

            {/* Роуты с EmptyLayout */}
            <Route element={renderEmptyLayout()}>
                <Route path={ApplicationRoutes.PromoResearch} element={<PromoResearchPage />} />
                <Route path={ApplicationRoutes.PromoMuseumNight} element={<PromoMuseumNightPage />} />
            </Route>

            <Route element={renderLayout()}>
                <Route path={ApplicationRoutes.Main} element={<HomePage />} />
                <Route path={ApplicationRoutes.Category} element={<HomePage />} />
                <Route path={ApplicationRoutes.Search} element={<SearchPage />} />
                <Route path={ApplicationRoutes.Study} element={<CourseListPage />} />
                <Route path={ApplicationRoutes.Compete} element={<ChallengeListPage />} />
            </Route>
            <Route path={ApplicationRoutes.Course} element={<CoursePage />} />
            <Route path={ApplicationRoutes.Chapter} element={<ChapterPage />} />
            <Route path={ApplicationRoutes.Prompt} element={<PromptPage />} />
            <Route path={ApplicationRoutes.Challenge} element={<ChallengePage />} />

            <Route
                path={ApplicationRoutes.NewPrompt}
                element={
                    <ProtectedRoute>
                        <NewPromptPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={ApplicationRoutes.NewPromptSuccess}
                element={
                    <ProtectedRoute>
                        <NewPromptSuccessPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={ApplicationRoutes.NewPromptFailure}
                element={
                    <ProtectedRoute>
                        <NewPromptFailurePage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={ApplicationRoutes.NewPromptStatus}
                element={
                    <ProtectedRoute>
                        <NewPromptStatusPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path={ApplicationRoutes.Profile}
                element={
                    <ProtectedRoute>
                        <MyProfilePage />
                    </ProtectedRoute>
                }
            >
                <Route path={ProfileNestedRoutes.Prompts} element={<MyProfilePrompts />} />
                <Route path={ProfileNestedRoutes.Favorites} element={<MyProfileFavorites />} />
                <Route path={ProfileNestedRoutes.Rating} element={<MyProfileRating />} />
                <Route path={ProfileNestedRoutes.Achievements} element={<ProfileAchievements />} />
            </Route>

            <Route path={ApplicationRoutes.UserProfile} element={<ProfilePage />}>
                <Route index element={<ProfilePrompts />} />
                <Route path={ProfileNestedRoutes.Rating} element={<ProfileRating />} />
                <Route path={ProfileNestedRoutes.Achievements} element={<ProfileAchievements />} />
            </Route>

            {/* Catch-all роут для несуществующих страниц */}
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};
